import { getNotifications } from '@api';
import { useFeatureFlags } from '@launcher/context/FeatureFlags.context';
import { useQuery } from '@tanstack/react-query';

export const NOTIFICATIONS_QUERY_KEY = 'notifications';
const NOTIFICATIONS_STALE_TIME_WITHOUT_REALTIME = 60 * 60 * 1000; // 1 hour

export const useNotifications = () => {
  const featureFlags = useFeatureFlags();
  const isRealtimeEnabled = featureFlags['enable-realtime-error-notifications'];

  return useQuery({
    queryKey: [NOTIFICATIONS_QUERY_KEY],
    queryFn: getNotifications,
    staleTime: isRealtimeEnabled ? Infinity : NOTIFICATIONS_STALE_TIME_WITHOUT_REALTIME,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
